// extracted by mini-css-extract-plugin
export default {"companyContainer":"nN-z","companyImage":"oN-z","container":"pN-z","heading":"qN-z","darkText":"rN-z","smallHeading":"sN-z","darkBackground":"tN-z","whiteBackground":"uN-z"};